/* eslint-disable react/no-unused-prop-types,react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

import ReferralLinkPanel from '../../../../../components/UserReferral/ReferralLinkPanel';

import groupsSearchCollector from '../../../../../components/Hocs/GroupsSearchCollector';
import PromotionalMaterialsListFromUser from '../../../../../components/PromotionalMaterials/PromotionalMaterialsListFromUser';

const bannersGroupsSearchCollector = groupsSearchCollector({
  'prom-mat': {
    component: PromotionalMaterialsListFromUser,
    listReduceName: 'promotionalMaterialsModule.lists.promMaterialsList'
  }
});

class PromotionalMaterials extends Component {
  render() {
    return (
      <Switch>
        <Route
          exact
          path={`/referral-program/promotional-materials`}
          render={() => (
            <Redirect to={`/referral-program/promotional-materials/my-link`} />
          )}
        />
        <Route
          path={`/referral-program/promotional-materials/my-link`}
          render={() => <ReferralLinkPanel />}
        />
        <Route
          key={`bannersGroupsSearchCollector`}
          path={`/referral-program/promotional-materials/banners`}
          render={bannersGroupsSearchCollector}
        />
      </Switch>
    );
  }
}

PromotionalMaterials.contextTypes = {
  router: PropTypes.shape()
};

PromotionalMaterials.propTypes = {
  // IN
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(PromotionalMaterials);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/ReferralProgram/PromotionalMaterials/PromotionalMaterials.js